/**
 * Global app constants — barrel re-exports.
 * Mock data lives under ./mockData/ (temporary until API integration).
 */
export {
  POST_PRIVACY,
  POST_SUGGESTED_HASHTAGS,
  POST_COMPOSER_HASHTAGS,
  POST_FEELINGS,
  POST_MAX_CHAR_COUNT,
  POST_MAX_IMAGE_SIZE_BYTES,
  POST_MAX_VIDEO_SIZE_BYTES,
  POST_GALLERY_MAX_IMAGES,
  POST_MEDIA_TYPE,
  POST_IMAGE_LAYOUT,
  POST_IMAGE_LAYOUT_SLOT_COUNT,
  SUPPORTED_VIDEO_MIME_TYPES,
  SUPPORTED_IMAGE_MIME_TYPES,
  SUPPORTED_IMAGE_EXTENSIONS,
  isSupportedImageFormat,
} from './createPost';

export {
  POST_PHOTO_PICKER_OPTIONS,
  COMPARE_PHOTO_PICKER_OPTIONS,
  POST_VIDEO_PICKER_OPTIONS,
} from './createPostMedia';

export { AI_BUDDIES } from './aiBuddyConstants';

export { countryCodeToFlag, COUNTRIES } from './countries';

export { ROBI_CHAT_USER, ROBI_CONVERSATION_ID, generateRobiMessageId } from './robiChat';

export {
  NOTIFICATION_CHANNEL,
  NOTIFICATION_TYPES,
  DEDUPE_WINDOW_MS,
  NOTIFICATION_ROUTE_TARGETS,
  NOTIFICATION_TABS,
} from './notificationConstants';

export { CommentContentType, PostContentType, ChatContentType } from './contentTypes';

export {
  GIPHY_API_BASE_URL,
  GIPHY_ENDPOINTS,
  GIPHY_RESULT_LIMIT,
  GIPHY_SEARCH_DEBOUNCE_MS,
  GIF_MIME_TYPE,
} from './giphy';

export {
  COMMENT_ATTACHMENT_PLACEHOLDER_FILENAMES,
  isCommentAttachmentPlaceholder,
  isCommentMediaSameAsAvatar,
} from './commentMedia';

export {
  CHAT_FEATURES,
  MIN_GROUP_CHAT_MEMBERS,
  MAX_GROUP_CHAT_MEMBERS,
} from './chatFeatures';
export {
  CONVERSATION_TYPE,
  AI_CONVERSATION_TYPES,
  CONVERSATIONS_PAGE_SIZE,
  PARTICIPANT_SELECTION_MODE,
  isGroupConversationType,
  isAiConversationType,
  isDirectConversationType,
} from './conversation';
export type {
  ConversationType,
  ParticipantSelectionMode,
} from './conversation';

export {
  SCREEN_WIDTH,
  SCREEN_HEIGHT,
  BASE_WIDTH,
  BASE_HEIGHT,
  SCALE_FACTOR,
  VERTICAL_SCALE_FACTOR,
  IS_IOS,
  IS_ANDROID,
  IS_TABLET,
} from './layout';

export { APP_NAME, APP_VERSION, API_TIMEOUT, PAGE_SIZE, GOOGLE_SIGN_IN_CONFIG } from './app';
export { STORAGE_KEYS, USER_SESSION_STORAGE_KEYS, APP_PERSIST_STORAGE_KEYS } from './storage';

export { ROUTES } from './routes';

export { REGEX } from './regex';

export { ERROR_MESSAGES, HTTP_STATUS } from './errors';

export { GROUP_TABS, GROUP_PRIVACY, GROUP_POST_PERMISSION, GROUP_STATUS } from './groups';
export type { GroupTabKey } from './groups';

export {
  PROFILE_TABS,
  PROFILE_TABS_PUBLIC,
  PROFILE_TAB_KEYS,
  PROFILE_TAB_KEYS_PUBLIC,
  getProfileTabApiAction,
  getProfileTabs,
  getProfileTabKeys,
} from './profileTabs';
export type { ProfileTabKey, ProfileTabAction } from './profileTabs';

export {
  PRIVACY_LEVEL,
  PRIVACY_ID_TO_PROFILE_VISIBILITY,
  PRIVACY_ID_TO_FIELD_VISIBILITY,
  PRIVACY_LABEL_TO_ID,
  PROFILE_VISIBILITY_TO_ID,
  FIELD_VISIBILITY_TO_ID,
  toPrivacyLevel,
} from './privacy';
export type { PrivacyLevel } from './privacy';

export const SAVED_POST_TABS = ['All', 'Text', 'Photos', 'Videos', 'Groups'];
